import {
  Dashboard,
  AccountBalance,
  People,
  Person,
  Settings,
  Assessment,
  MonetizationOn,
  CreditCard,
  AccountBalanceWallet,
  TrendingUp,
  Receipt,
  Assignment,
  Group,
  Business,
  LocalAtm,
  Savings,
  Payment,
  AccountBox,
  ListAlt,
  Category,
  Description,
  Security,
  AdminPanelSettings,
  SupervisorAccount,
  ManageAccounts,
  AccountTree,
  CurrencyRupee,
  Calculate,
  PieChart,
  BarChart,
  Timeline,
  Folder,
  FolderOpen,
  Article,
  BookmarkBorder,
  Bookmark,
  Star,
  StarBorder
} from '@mui/icons-material';

// Icon mapping for different menu categories and items
export const getMenuIcon = (pageLabel, controller, parentPageLabel) => {
  const label = pageLabel?.toLowerCase() || '';
  const path = controller?.toLowerCase() || '';
  const parent = parentPageLabel?.toLowerCase() || '';

  // Dashboard
  if (label.includes('dashboard') || path.includes('dashboard')) {
    return Dashboard;
  }

  // Masters/Configuration
  if (parent.includes('master') || label.includes('master')) {
    if (label.includes('account') || label.includes('acc')) {
      return AccountBox;
    }
    if (label.includes('loan') || label.includes('credit')) {
      return MonetizationOn;
    }
    if (label.includes('member') || label.includes('customer')) {
      return People;
    }
    if (label.includes('branch') || label.includes('office')) {
      return Business;
    }
    if (label.includes('user') || label.includes('staff')) {
      return SupervisorAccount;
    }
    if (label.includes('category') || label.includes('type')) {
      return Category;
    }
    return Settings;
  }

  // Accounts
  if (label.includes('account') || path.includes('account')) {
    if (label.includes('saving') || label.includes('deposit')) {
      return Savings;
    }
    if (label.includes('current') || label.includes('checking')) {
      return AccountBalanceWallet;
    }
    if (label.includes('loan') || label.includes('credit')) {
      return CreditCard;
    }
    return AccountBalance;
  }

  // Loans
  if (label.includes('loan') || path.includes('loan')) {
    if (label.includes('type') || label.includes('category')) {
      return Category;
    }
    if (label.includes('application') || label.includes('apply')) {
      return Assignment;
    }
    if (label.includes('disburs') || label.includes('release')) {
      return LocalAtm;
    }
    if (label.includes('repay') || label.includes('payment')) {
      return Payment;
    }
    return MonetizationOn;
  }

  // Members/Customers
  if (label.includes('member') || label.includes('customer') || label.includes('client')) {
    if (label.includes('group') || label.includes('committee')) {
      return Group;
    }
    if (label.includes('individual') || label.includes('personal')) {
      return Person;
    }
    return People;
  }

  // Transactions
  if (label.includes('transaction') || label.includes('trans') || path.includes('transaction')) {
    if (label.includes('deposit') || label.includes('credit')) {
      return TrendingUp;
    }
    if (label.includes('withdraw') || label.includes('debit')) {
      return LocalAtm;
    }
    if (label.includes('transfer')) {
      return AccountTree;
    }
    return Receipt;
  }

  // Reports
  if (label.includes('report') || path.includes('report')) {
    if (label.includes('chart') || label.includes('graph')) {
      return BarChart;
    }
    if (label.includes('summary') || label.includes('overview')) {
      return PieChart;
    }
    if (label.includes('trend') || label.includes('analysis')) {
      return Timeline;
    }
    return Assessment;
  }

  // Administration
  if (label.includes('admin') || label.includes('administration')) {
    if (label.includes('user') || label.includes('staff')) {
      return ManageAccounts;
    }
    if (label.includes('security') || label.includes('permission')) {
      return Security;
    }
    if (label.includes('setting') || label.includes('config')) {
      return Settings;
    }
    return AdminPanelSettings;
  }

  // Financial
  if (label.includes('financial') || label.includes('finance')) {
    if (label.includes('calculation') || label.includes('calc')) {
      return Calculate;
    }
    if (label.includes('currency') || label.includes('money')) {
      return CurrencyRupee;
    }
    return MonetizationOn;
  }

  // Documents/Files
  if (label.includes('document') || label.includes('file') || label.includes('doc')) {
    return Description;
  }

  // Lists/Categories
  if (label.includes('list') || label.includes('listing')) {
    return ListAlt;
  }

  // Default icons based on common patterns
  if (label.includes('setting') || label.includes('config')) {
    return Settings;
  }

  if (label.includes('user') || label.includes('profile')) {
    return Person;
  }

  if (label.includes('business') || label.includes('company')) {
    return Business;
  }

  // Default fallback icon
  return Folder;
};

// Get icon for submenu items (usually simpler icons)
export const getSubMenuIcon = (pageLabel, controller) => {
  const label = pageLabel?.toLowerCase() || '';
  
  // Use bookmark icons for submenu items to maintain hierarchy
  if (label.includes('add') || label.includes('create') || label.includes('new')) {
    return Star;
  }
  
  if (label.includes('list') || label.includes('view') || label.includes('manage')) {
    return ListAlt;
  }
  
  if (label.includes('edit') || label.includes('update') || label.includes('modify')) {
    return Bookmark;
  }
  
  // Default submenu icon
  return StarBorder;
};

export default {
  getMenuIcon,
  getSubMenuIcon
};